<template>
</template>

<script>

    import PreviewElement from "./PreviewElement";
    import ColumnWrapperElement from "../../components/pagesbuilder/elements/ColumnWrapperElement";

    export default {
        name: "PreviewColumnWrapperElement",
        mixins: [PreviewElement,ColumnWrapperElement]
    }
</script>
